import React from 'react';
import { Field, ErrorMessage } from 'formik';

/**
 * Reusable NumberField component with Formik integration
 * Automatically blocks invalid characters (e, E, +, -, .)
 * Does NOT include a column wrapper — place inside a col-md-X div.
 * 
 * @param {Object} props - Component props
 * @param {string} props.name - Formik field name
 * @param {string} props.label - Field label text
 * @param {boolean} props.required - Whether field is required (shows red asterisk)
 * @param {string} props.placeholder - Placeholder text
 * @param {string|number} props.min - Minimum value (default: "0")
 * @param {string|number} props.max - Maximum value
 * @param {boolean} props.disabled - Whether field is disabled
 * @param {string} props.className - Additional CSS classes for the input
 */
const NumberField = ({
  name,
  label,
  required = false,
  placeholder = "",
  min = "0",
  max,
  disabled = false,
  className = "",
}) => {
  return (
    <div className="form-group">
      <label htmlFor={name} className="form-label">
        {required && <span style={{ color: "red", fontSize: "20px" }}>*</span>}
        {label}
      </label>
      <Field
        id={name}
        name={name}
        type="number"
        min={min}
        max={max}
        disabled={disabled}
        className={`form-control input-width ${className}`}
        placeholder={placeholder}
        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
      />
      <ErrorMessage name={name} component="div" className="text-danger" />
    </div>
  );
};

export default NumberField;
